const keysToOmit = ["translations"];
// Recursively removes the given keys (by name, any value type) from a response.
export const omitKeysDeep = <T>(data: T, keys: string[]): T => {
    const keySet = new Set(keys);

    const walk = (value: unknown): unknown => {
        if (Array.isArray(value)) {
            return value.map(walk);
        }
        if (value !== null && typeof value === "object") {
            const result: Record<string, unknown> = {};
            for (const [key, val] of Object.entries(value)) {
                if (keySet.has(key)) continue;
                result[key] = walk(val);
            }
            return result;
        }
        return value;
    };

    return walk(data) as T;
};

export const stripKeys = <T>(data: T): T => omitKeysDeep(data, keysToOmit);
